export default "__VITE_ASSET__vXZv05Xr__"